var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"immutable-field"},[_c('FormFieldLabel',{staticClass:"label",attrs:{"title":_vm.$t(_vm.title)}}),_c('span',[_vm._v(_vm._s(_vm.text))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }